function init() {
  var inputimgs = document.querySelectorAll(".input_img");
  if (!inputimgs) return;
  inputimgs.forEach(function (inputimg) {
    let id = inputimg?.id?.split("*")[1];
    inputimg.addEventListener("click", function () {
      let idName = id + "__main--customerpassword";
      var form_control_input = document.querySelector("#" + id);
      if (form_control_input) {
        if (form_control_input.type == "password") {
          // document.querySelector(".input_img_hidden").hidden = true;
          // document.querySelector(".input_img_view").hidden = false;
          document.querySelector("#" + id).type = "text";
            inputimg.src = "//ringconn.com/cdn/shop/t/154/assets/view.svg?v=93999776838137558691762311224"
        } else {
          // document.querySelector(".input_img_hidden").hidden = false;
          // document.querySelector(".input_img_view").hidden = true;
          document.querySelector("#" + id).type = "password";
          inputimg.src = "//ringconn.com/cdn/shop/t/154/assets/hidden.svg?v=79978484582135763311762311194"
        }
      }
    });
  });
}
setTimeout(init(), 1000);
